module.exports = __webpack_public_path__ + "media/images/amenities_icons/photo_studio-190f4c273ebc21cfe3e3592c20c0fc34.svg";